import React, { useState, useEffect } from 'react';
import { translate } from '../Services/translation';
let fromDate = null;
let toDate = null;
let daysArray = null;

const BookingDate = () => {
    const [defaultToDate, setDefaultToDate] = useState(null);
    const [defaultFromDate, setDefaultFromDate] = useState(null);
    const [dateList, setDateList] = useState([]);
    const [quantity, setQuantity] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
    const dayNames = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"];
    let allMonths = [];
    let currentMonthName = "";
    let amountOfNightsLabel = "";
    if (document.getElementById("amount-of-nights")) {
        amountOfNightsLabel = document.getElementById("amount-of-nights")
    }
    let selectedDatesList = [];
    let monthDayFromDate = "";
    let monthDaytoDate = "";

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        if (window.innerWidth < 640) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
        if (amountOfNightsLabel != "") {
            amountOfNightsLabel.innerHTML = 0;
        }
        getListOfDates();
        getMonthes();
        checkAvailableDates();
        changeBackgroundColor();
        makeAvailableToClick();
        changeDateLabels();
        function checkWindowSize() {
            if (window.innerWidth < 640) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }
        window.addEventListener('resize', checkWindowSize);
        return () => {
            window.removeEventListener('resize', checkWindowSize);
        };
    }, [currentMonthIndex, isMobile]);

    const handleClick = (selectedDate) => {
        let isSameDayCheckoutProduct = checkIsSameDayCheckoutProduct();
        if (!isSameDayCheckoutProduct) {
            for (let i = 0; i < dateList.length; i++) {
                if (!fromDate && !toDate) {
                    fromDate = selectedDate;
                    break;
                }
                else if (fromDate && !toDate) {
                    if (selectedDate == fromDate) {
                        fromDate = selectedDate;
                        toDate = null;
                    } else {
                        let beforeFromDate = compareTwoDates(fromDate, selectedDate);
                        beforeFromDate ? fromDate = selectedDate : toDate = selectedDate
                        break;
                    }
                }
                else if (fromDate && toDate) {
                    for (let j = 0; j < dateList.length; j++) {
                        let divDate = dateList[j].date;
                        let divStock = dateList[j].stock;
                        if (divDate === selectedDate && divStock === 0) {
                            toDate = null;
                            fromDate = null;
                            break;
                        } else if (divDate === toDate) {
                            fromDate = selectedDate;
                            toDate = null;
                            break;
                        } else if (divDate != toDate && divStock != 0 && selectedDate != toDate) {
                            toDate = null;
                            fromDate = selectedDate;
                            break;
                        }
                    }
                    break;
                }
            }
            resetInsideColor();
            checkAvailableDates();
            changeBackgroundColor();
            makeAvailableToClick();
            calculateQuantity(isSameDayCheckoutProduct);
            changeDateLabels();
        }
        // logic for same Day Checkout Products 
        else {
            for (let i = 0; i < dateList.length; i++) {
                if (!fromDate && !toDate) {
                    fromDate = selectedDate;
                    toDate = selectedDate
                    break;
                }
                else if (fromDate && toDate) {
                    let isSelectedDateBeforeFromDate = compareTwoDates(fromDate, selectedDate);
                    for (let j = 0; j < dateList.length; j++) {
                        let divDate = dateList[j].date;
                        let divStock = dateList[j].stock;
                        if (divDate != toDate && isSelectedDateBeforeFromDate) {
                            fromDate = selectedDate;
                            toDate = selectedDate;
                            break;
                        } else if (selectedDate != fromDate && selectedDate != toDate && toDate != fromDate) {
                            fromDate = selectedDate;
                            toDate = selectedDate;
                            break;
                        } else if (divDate != toDate && divStock != 0 && selectedDate != toDate && !isSelectedDateBeforeFromDate) {
                            toDate = selectedDate;
                            break;
                        }
                    }
                    break;
                }
            }
            resetInsideColor();
            checkAvailableDates();
            changeBackgroundColor();
            calculateQuantity(isSameDayCheckoutProduct);
            changeDateLabels();
        }
    }

    //Make the the first out of stock available to click as checkout
    const makeAvailableToClick = () => {
        for (let i = 0; i < daysArray.length; i++) {
            let nestedDateList = daysArray[i];
            if (daysArray[i + 1]) {
                nestedDateList = [...daysArray[i], ...daysArray[i + 1]];
            }
            for (let i = 0; i < nestedDateList.length; i++) {
                let stock = "";
                let divDate = "";
                let id = nestedDateList[i].id;
                let divToChange = document.getElementById(id);
                if (divToChange) {
                    stock = divToChange.getAttribute("data-stock");
                    divDate = divToChange.getAttribute("data-date");
                }

                if (divToChange) {
                    if (divToChange.classList.contains("date-stock--ableToClick")) {
                        divToChange.classList.remove("date-stock--ableToClick");
                    }
                    if (fromDate && toDate && (divDate === toDate)) {
                        divToChange.classList.remove("date-stock--not-available");
                    }
                    if (!divToChange.classList.contains("date-stock--ableToClick") && stock === "0" && (divDate != toDate)) {
                        divToChange.classList.add("date-stock--not-available");
                    }
                }
            }
        }
        if (fromDate && !toDate) {
            let looped = false;
            for (let i = 0; i < daysArray.length; i++) {
                let nestedDateList = daysArray[i];
                if (daysArray[i + 1]) {
                    nestedDateList = [...daysArray[i], ...daysArray[i + 1]]
                }
                if (!looped) {
                    for (let c = 0; c < nestedDateList.length; c++) {
                        let date = nestedDateList[c].date;
                        if (fromDate === date) {
                            for (let x = c + 1; x < nestedDateList.length; x++) {
                                let available = nestedDateList[x].available;
                                let id = nestedDateList[x].id;
                                if (!available) {
                                    if (document.getElementById(id)) {
                                        let divToChange = document.getElementById(id);
                                        divToChange.classList.remove("date-stock--not-available");
                                        divToChange.classList.add("date-stock--ableToClick");
                                        looped = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    //Check if chosen date is before check-in date 
    const compareTwoDates = (fromDate, selectedDate) => {
        const fromDateObject = new Date(fromDate);
        const selectedDateObject = new Date(selectedDate);
        if (fromDateObject > selectedDateObject) {
            return true;
        } else {
            return false;
        }
    }

    const changeBackgroundColor = () => {
        let dateStockDiv = "";
        if (document.getElementsByClassName("date-stock")) {
            dateStockDiv = document.getElementsByClassName("date-stock");
        }
        if (dateStockDiv !== "") {
            for (let i = 0; i < dateStockDiv.length; i++) {
                let selectedDiv = document.getElementById(dateStockDiv[i].id);
                let selectedDate = selectedDiv.getAttribute("data-date");
                if (((selectedDate !== fromDate) && (selectedDate !== toDate))) {
                    if (selectedDiv.classList.contains("date-stock--selectedFrom")) {
                        selectedDiv.classList.remove("date-stock--selectedFrom");
                    } if (selectedDiv.classList.contains("date-stock--selectedTo")) {
                        selectedDiv.classList.remove("date-stock--selectedTo");
                    }
                }
                if ((selectedDate === fromDate) || (selectedDate === toDate)) {
                    if ((selectedDate === fromDate) && !selectedDiv.classList.contains("date-stock--selectedFrom")) {
                        if (selectedDiv.classList.contains("date-stock--selectedTo")) {
                            selectedDiv.classList.remove("date-stock--selectedTo");
                        }
                        selectedDiv.classList.add("date-stock--selectedFrom");
                    } if (selectedDate === toDate && !selectedDiv.classList.contains("date-stock--selectedTo")) {
                        if (selectedDiv.classList.contains("date-stock--selectedFrom")) {
                            selectedDiv.classList.remove("date-stock--selectedFrom");
                        }
                        selectedDiv.classList.add("date-stock--selectedTo");
                        selectedDiv.classList.remove("date-stock--not-available");
                    }
                }
                if (!fromDate && !toDate) {
                    let stock = selectedDiv.getAttribute("data-stock");;
                    if (stock === "0") {
                        selectedDiv.classList.add("date-stock--not-available");
                    }
                }
            }
            if (selectedDatesList.length >= 3 && fromDate && toDate) {
                for (let i = 1; i < selectedDatesList.length - 1; i++) {
                    let id = selectedDatesList[i].id;
                    let betweenDates = document.getElementById(id);
                    if (betweenDates) {
                        betweenDates.classList.remove("date-stock--not-available");
                        betweenDates.classList.remove("date-stock--available");
                        betweenDates.classList.add("date-stock--selected-inside");
                    }
                }
            }
            if (fromDate && toDate) {
                let changeSearchText = translate('booking.button.change.search.dates');
                if (document.getElementById("searchDatesButton")) {
                    document.getElementById("searchDatesButton").innerHTML = changeSearchText;
                }
            }
        }
    }

    const checkIsSameDayCheckoutProduct = () => {
        let result = false;
        if (document.getElementById("product-availability")) {
            let isSameDayCheckout = document.getElementById("product-availability").getAttribute("data-issamedaycheckout");
            if (isSameDayCheckout === "True" && isSameDayCheckout != null) {
                result = true;
            }
        }
        return result;
    }

    const getMonthes = () => {
        let result = [];
        let dateList;
        if (document.getElementById("product-availability")) {
            if (document.getElementById("product-availability").getAttribute("value")) {
                try {
                    dateList = JSON.parse(document.getElementById("product-availability").getAttribute("value"));
                } catch { }
            }
        }
        dateList.forEach((obj) => {
            const month = Number(obj.date.split("-")[1]) - 2;
            if (!result[month]) {
                const firstDate = new Date(obj.date.substring(0, 7) + "-01");
                const lastDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 1, 0);
                const dates = [];
                for (let i = 1; i <= lastDate.getDate(); i++) {
                    const dateString = obj.date.substring(0, 7) + "-" + (i < 10 ? "0" + i : i);
                    const dateObj = {
                        id: Math.floor(Math.random() * 1000000),
                        date: dateString,
                        stock: 0,
                        available: false,
                        checkoutOnly: true,
                    };
                    dates.push(dateObj);
                }
                result[month] = dates;
            }
            const dateIndex = obj.date.split("-")[2] - 1;
            result[month][dateIndex].id = obj.id;
            result[month][dateIndex].stock = obj.stock;
            result[month][dateIndex].available = obj.available;
            result[month][dateIndex].checkoutOnly = obj.checkoutOnly;
        });
        daysArray = removeEmptySlots(result);
    };

    const removeEmptySlots = (arr) => {
        return arr.filter((el) => {
            return el.length > 0;
        });
    };

    const createDatePicker = (result) => {
        const numberOfMonths = Object.keys(result).length;
        for (let i = 0; i < numberOfMonths; i++) {
            if (result.length > 0) {
                const months = result[i].map(obj => {
                    const date = new Date(obj.date);
                    const year = date.getFullYear();
                    const month = date.getMonth();
                    const daysInMonth = new Date(year, month + 1, 0).getDate();
                    const firstDayOfMonth = new Date(year, month, 1).getDay();
                    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
                    const emptyDays = Array.from({ length: firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1 }, () => null);
                    return { year, month, monthName: date.toLocaleString('sv-SE', { month: 'long' }), days, emptyDays };
                });
                allMonths.push(months);
            }
        }
        let numberOfMonth = allMonths.length;
        let className = numberOfMonth > 1 ? "multiMonths" : "singleMonth";
        if (isMobile) {
            return (
                <div className="date-picker-modal" >
                    {renderMonthSection(currentMonthIndex, result, isMobile)}
                </div>
            );
        }
        else {
            return (
                <div className="date-picker-modal">
                    <div className={`desktopTabletMonths ${className}`}>
                        {renderMonthSection(currentMonthIndex, result, isMobile)}
                        {renderMonthSection(currentMonthIndex + 1, result, isMobile)}
                    </div>
                </div>
            );
        }
    }

    function renderMonthSection(monthIndex, result, isMobile) {
        let monthData;
        if (Array.isArray(allMonths) && allMonths.length > monthIndex && Array.isArray(allMonths[monthIndex]) && allMonths[monthIndex].length > 0) {
            monthData = allMonths[monthIndex][0];
            currentMonthName = monthData.monthName;
        }
        let divIdName = Object.keys(allMonths).length > 1 ? "" : "header_fromDateTo";
        if (monthData) {
            return (
                <div className="date-picker-container">
                    {isMobile ?
                        <div className="datePickerHeader">
                            {currentMonthIndex > 0 && (
                                <div className="datePickerHeader__prev-btn" onClick={() => { setCurrentMonthIndex(currentMonthIndex => Math.max(currentMonthIndex - 1, 0)); changeBackgroundColor(); }}>
                                    <i className="arrow-icon prev-arrow"></i>
                                </div>
                            )}
                            <div className="datePickerHeader--fromTo">
                                <label id="header_fromDateTo"></label>
                                <div id="header_monthName" className="monthName">{`${monthData.monthName}`}</div>
                            </div>
                            {currentMonthIndex < allMonths.length - 1 && (
                                <div className="datePickerHeader__next-btn"
                                    onClick={() => { setCurrentMonthIndex(currentMonthIndex => Math.min(currentMonthIndex + 1, allMonths.length - 1)); changeBackgroundColor(); }} >
                                    <i className="arrow-icon next-arrow"></i>
                                </div>
                            )}
                        </div>
                        :
                        <div className="datePickerHeader">
                            {currentMonthIndex > 0 && (
                                <div className="datePickerHeader__prev-btn" onClick={() => { setCurrentMonthIndex(currentMonthIndex => Math.max(currentMonthIndex - 1, 0)); changeBackgroundColor(); }}>
                                    <i className="arrow-icon prev-arrow"></i>
                                </div>
                            )}
                            <div className="datePickerHeader--fromTo">
                                <label id={divIdName}></label>
                                <div id="header_monthName" className="monthName">{`${monthData.monthName}`}</div>
                            </div>
                            {currentMonthIndex < allMonths.length - 2 && (
                                <div className="datePickerHeader__next-btn"
                                    onClick={() => { setCurrentMonthIndex(currentMonthIndex => Math.min(currentMonthIndex + 1, allMonths.length - 2)); changeBackgroundColor(); }} >
                                    <i className="arrow-icon next-arrow"></i>
                                </div>
                            )}
                        </div>
                    }
                    <div className="days-of-week">
                        {dayNames.map(dayName => (
                            <div key={dayName} className="day">{dayName}</div>
                        ))}
                    </div>
                    <div className="days">
                        {monthData.emptyDays.map((_, index) => (
                            <div key={index} className="day"></div>
                        ))}
                        {monthData.days.map((day) => {
                            const date = result[monthIndex].find(obj => new Date(obj.date).getDate() === day);
                            const now = new Date();
                            now.setHours(0, 0, 0, 0);
                            const dateObj = new Date(date.date);
                            dateObj.setHours(0, 0, 0, 0);
                            const isPast = dateObj < now;
                            return (
                                <div
                                    onClick={() => handleClick(date.date)}
                                    data-date={`${date.date}`}
                                    id={`${date.id}`}
                                    className={`date-stock day ${date.stock <= 0 || isPast ? "date-stock--not-available" : "date-stock--available"}`}
                                    data-stock={`${date.stock}`}
                                    key={date.date}
                                >
                                    <div>
                                        {parseInt(date.date.substr(8), 10).toString()}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            );
        }
    }

    const getListOfDates = () => {
        if (document.getElementById("product-availability")) {
            if (document.getElementById("product-availability").getAttribute("value")) {
                try {
                    let dateList = JSON.parse(document.getElementById("product-availability").getAttribute("value"));
                    dateList && dateList.sort(function (a, b) {
                        return new Date(a.date) - new Date(b.date);
                    });
                    setDateList(dateList);
                    setDefaultFromDate(translate('modal.choose.date'));
                    setDefaultToDate(translate('modal.choose.date'));
                } catch { }
            }
        }
    }

    //Check that the selected dates do not contain an unavailable date
    const checkAvailableDates = () => {
        selectedDatesList = [];
        let foundObject = false;
        if (toDate && fromDate) {
            let lopped = false;
            for (let i = 0; i < daysArray.length; i++) {
                let nestedArray = daysArray[i];
                if (!lopped) {
                    for (let x = 0; x < nestedArray.length; x++) {
                        let dateToAdd = nestedArray[x];
                        if (nestedArray[x].date === fromDate) {
                            foundObject = true;
                        }
                        if (foundObject) {
                            selectedDatesList.push(dateToAdd);
                        }
                        if (dateToAdd.date === toDate) {
                            lopped = true;
                            break;
                        }
                    }
                }
            }
        }
        if (selectedDatesList.length >= 3) {
            for (let i = 0; i < selectedDatesList.length - 1; i++) {
                if (!selectedDatesList[i].available) {
                    for (let i = 1; i < selectedDatesList.length - 1; i++) {
                        let id = selectedDatesList[i].id;
                        if (document.getElementById(id)) {
                            let betweenDates = document.getElementById(id);
                            betweenDates.classList.remove("date-stock--selected-inside");
                            if (selectedDatesList[i].available) {
                                betweenDates.classList.add("date-stock--available");
                            } if (!selectedDatesList[i].available) {
                                betweenDates.classList.add("date-stock--not-available");
                            }
                        }
                    }
                    fromDate = null;
                    toDate = null;
                    selectedDatesList = [];
                    if (document.getElementById("modal-error-message")) {
                        const errorMessage = document.getElementById("modal-error-message");
                        if (errorMessage.classList.contains("modal-error-container__hide")) {
                            errorMessage.classList.remove("modal-error-container__hide");
                            errorMessage.classList.add("modal-error-container__show");
                        }
                    }
                    break;
                }
            }
        } else {
            if (document.getElementById("modal-error-message")) {
                const errorMessage = document.getElementById("modal-error-message");
                if (errorMessage.classList.contains("modal-error-container__show")) {
                    errorMessage.classList.remove("modal-error-container__show");
                    errorMessage.classList.add("modal-error-container__hide");
                }
            }
        }
    }

    const calculateTotalPrice = (nightAmount) => {
        let result = 0;
        if (document.getElementById("productPriceContainer")) {
            if (document.getElementById("productPriceContainer").children[0].innerHTML) {
                try {
                    let doc = document.getElementById("productPriceContainer").children[0].innerHTML;
                    let numbers = doc.split(" ").map(Number);
                    let joined = parseInt(numbers.join(''));
                    result = joined * nightAmount;
                } catch { }
            }
        }
        return result;
    }

    const createSearchDatesButton = () => {
        return (
            !isVisible &&
            <button className="searchDatesButton" id="searchDatesButton" onClick={() => { handleToggle() }}>{translate('booking.button.search.dates')}</button>
        )
    }

    const clearSelectedDates = () => {
        for (let i = 0; i < dateList.length; i++) {
            if (dateList[i].available) {
                fromDate = null;
                toDate = null;
                break;
            }
        }
        clearBackgroundColor();
    }

    const clearBackgroundColor = () => {
        fromDate = null;
        toDate = null;
        resetInsideColor();
        changeBackgroundColor();
    }

    const resetInsideColor = () => {
        for (let i = 0; i < dateList.length; i++) {
            let coloredDivId = dateList[i].id;
            if (document.getElementById(coloredDivId)) {
                let coloredDiv = document.getElementById(coloredDivId);
                if (coloredDiv.classList.contains("date-stock--selected-inside")) {
                    coloredDiv.classList.remove("date-stock--selected-inside");
                    coloredDiv.classList.add("date-stock--available");
                }
            }
        }
    }

    const calculateQuantity = (isSameDayCheckout) => {
        let date1 = new Date(fromDate);
        let date2 = new Date(toDate);
        let diffTime = Math.abs(date2 - date1);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        const totalPriceContainer = document.getElementById("totalPrice-container");
        const totalPriceAccommodation = document.getElementById("total-price-accommodation");
        if (isSameDayCheckout) {
            if (fromDate === toDate && (fromDate != null)) {
                diffDays = 1;
                showHideTotalPriceAndNights(diffDays, totalPriceContainer, totalPriceAccommodation);
            } else {
                diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
                showHideTotalPriceAndNights(diffDays, totalPriceContainer, totalPriceAccommodation);
            }
        }
        else {
            if (!fromDate || !toDate) {
                if (document.getElementById("amount-of-nights")) {
                    amountOfNightsLabel = document.getElementById("amount-of-nights");
                    amountOfNightsLabel.innerHTML = 0;
                }
            }
            if (fromDate && toDate) {
                showHideTotalPriceAndNights(diffDays, totalPriceContainer, totalPriceAccommodation);
            } else {
                setQuantity(0);
                if (totalPriceContainer) {
                    totalPriceContainer.classList.remove("info-container__price--show");
                    totalPriceContainer.classList.add("info-container__price--hide");
                }
                if (totalPriceAccommodation) {
                    totalPriceAccommodation.innerHTML = 0 + " SEK";
                }
            }
        }
    }

    const showHideTotalPriceAndNights = (diffDays, totalPriceContainer, totalPriceAccommodation) => {
        if (totalPriceContainer) {
            totalPriceContainer.classList.remove("info-container__price--hide");
            totalPriceContainer.classList.add("info-container__price--show");
        }
        setQuantity(diffDays);
        if (document.getElementById("amount-of-nights")) {
            amountOfNightsLabel = document.getElementById("amount-of-nights");
            amountOfNightsLabel.innerHTML = diffDays;
        }
        let productTotalPrice = calculateTotalPrice(diffDays);
        if (totalPriceAccommodation) {
            totalPriceAccommodation.innerHTML = productTotalPrice;
        }
        if (document.getElementById("total-price")) {
            document.getElementById("total-price").innerHTML = productTotalPrice;
        }
        if (totalPriceAccommodation) {
            totalPriceAccommodation.innerHTML = productTotalPrice + " SEK";
        }
    }

    const handleToggle = () => {
        setIsVisible(!isVisible);
        setTimeout(() => {
            checkAvailableDates();
            makeAvailableToClick();
            changeBackgroundColor();
            changeDateLabels();
        }, 10);
    };

    const handleClose = (event) => {
        if (event.target === event.currentTarget) {
            const isConfirmButtonClicked = event.target.classList.contains("button-container__confirm");
            if (isConfirmButtonClicked && fromDate && toDate) {
                setIsVisible(false);
            } else {
                setIsVisible(false);
            }
        }
    };

    const changeDateLabels = () => {
        const header_fromDateTo = document.getElementById("header_fromDateTo");
        const header_monthName = document.getElementById("header_monthName");

        if (fromDate) {
            monthDayFromDate = convertDateToMonthDay(fromDate);
            if (document.getElementById("selectedDateFromSpan")) {
                document.getElementById("selectedDateFromSpan").innerHTML = monthDayFromDate;
            }
        } else {
            if (document.getElementById("selectedDateFromSpan")) {
                selectedDateFromSpan.innerHTML = translate('booking.choose.checkin.date');
            }
        }
        if (toDate) {
            monthDaytoDate = convertDateToMonthDay(toDate);
            if (document.getElementById("selectedDateToSpan")) {
                document.getElementById("selectedDateToSpan").innerHTML = monthDaytoDate;
            }
            if (document.getElementById("checkOutHeader")) {
                document.getElementById("checkOutHeader").innerHTML = monthDaytoDate;
            }
        } else {
            if (document.getElementById("selectedDateFromSpan")) {
                selectedDateToSpan.innerHTML = translate('booking.choose.checkout.date');
            }
            if (document.getElementById("checkOutHeader")) {
                document.getElementById("checkOutHeader").innerHTML = defaultToDate;
            }
        }
        if (fromDate && toDate) {
            if (header_fromDateTo) {
                let fromDateDateFormat = new Date(fromDate);
                let fromDateMonthName = fromDateDateFormat.toLocaleString('default', { month: 'long' });
                let toDateDateFormat = new Date(toDate);
                let toDateMonthName = toDateDateFormat.toLocaleString('default', { month: 'long' });
                if (fromDateMonthName === toDateMonthName) {
                    header_monthName.innerHTML = "";
                    header_fromDateTo.innerHTML = parseInt(fromDate.substr(8), 10).toString() + " - " + parseInt(toDate.substr(8), 10).toString() + " " + fromDateMonthName;
                } else {
                    if (header_monthName) {
                        header_monthName.innerHTML = "";
                        header_fromDateTo.innerHTML = parseInt(fromDate.substr(8), 10).toString() + " " + fromDateMonthName + " - " +
                            parseInt(toDate.substr(8), 10).toString() + " " + toDateMonthName;
                    }
                }
            }
        } else {
            if (header_monthName && header_monthName.innerHTML === "") {
                header_fromDateTo.innerHTML = "";
                header_monthName.innerHTML = currentMonthName;
            }
        }
    }

    const convertDateToMonthDay = (dateString) => {
        let date = new Date(dateString);
        let month = date.toLocaleDateString('sv-SE', { month: 'long' });
        let day = date.getDate();
        let firstLetter = month.charAt(0).toUpperCase();
        let restOfMonth = month.substring(1, 3).toLowerCase();
        let result = firstLetter + restOfMonth + " " + day;
        return result;
    }

    const createDescription = () => {
        return (

            <div className="info-container">
                <div className="info-container__description">
                    <span className="info-container__description--icon"></span>
                    <span>{translate('modal.description.not.notavailable')}</span>
                </div>
                <div id="totalPrice-container" className="info-container__price info-container__price--hide">
                    <label className="detail-container__price" id="total-price">0</label>
                    <span>SEK</span>
                </div>
            </div>
        )
    }

    const clearDateSpan = () => {
        makeAvailableToClick();
        const header_fromDateTo = document.getElementById("header_fromDateTo");
        const totalPriceAccommodation = document.getElementById("total-price-accommodation");
        const totalPriceContainer = document.getElementById("totalPrice-container");
        const header_monthName = document.getElementById("header_monthName");
        if (document.getElementById("selectedDateFromSpan") && document.getElementById("selectedDateToSpan")) {
            let selectedDateFromSpan = document.getElementById("selectedDateFromSpan");
            let selectedDateToSpan = document.getElementById("selectedDateToSpan");
            selectedDateFromSpan.innerHTML = translate('booking.choose.checkin.date');
            selectedDateToSpan.innerHTML = translate('booking.choose.checkout.date');
        }
        if (totalPriceContainer) {
            totalPriceContainer.classList.remove("info-container__price--show");
            totalPriceContainer.classList.add("info-container__price--hide");
        }
        if (totalPriceAccommodation) {
            totalPriceAccommodation.innerHTML = 0 + " SEK";
        }
        if (header_fromDateTo) {
            header_fromDateTo.innerHTML = "";
        }
        if (header_monthName) {
            if (header_monthName.innerHTML === "") {
                header_monthName.innerHTML = currentMonthName;
            }
        }
        amountOfNightsLabel.innerHTML = 0;
        setQuantity(0);
    }

    const createButtonContainers = () => {
        return (
            <div className='button-container'>
                <div className="button-container__confirm" onClick={handleClose}>
                    {translate('modal.confirm.button')}
                </div>
                <div onClick={() => { clearSelectedDates(); clearDateSpan(); }} className='button-container__clear'>
                    {translate('modal.clear.dates.button')}
                </div>
            </div>
        )
    }

    const createErrorMessage = () => {
        return (
            <div id="modal-error-message" className="modal-error-container modal-error-container__hide">
                <span className="modal-error-container--icon">!</span>
                <label>{translate('booking.invalid.date.alert')}</label>
            </div>
        )
    }
    const createInOutcheckDateContainer = () => {
        return (
            <div className="in-outcheckDate-container">
                <div className="in-outcheckDate-container__parent">
                    <label className="in-outcheckDate-container__header">
                        {translate('booking.checkin.text')}
                    </label>
                    <div className="in-outcheckDate-container--datesContainer" onClick={() => { handleToggle() }}>
                        <span className="fa fa-calendar"></span>
                        <span className="datesContainer__date" id="selectedDateFromSpan">
                            {translate('booking.choose.checkin.date')}
                        </span>
                    </div>
                </div>
                <div className="in-outcheckDate-container__parent">
                    <label className="in-outcheckDate-container__header">
                        {translate('booking.checkout.text')}
                    </label>
                    <div className="in-outcheckDate-container--datesContainer" onClick={() => { handleToggle() }}>
                        <span className="fa fa-calendar"></span>
                        <span className="datesContainer__date" id="selectedDateToSpan">
                            {translate('booking.choose.checkout.date')}
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    const createQuantityPriceContainer = () => {
        const getDiv = document.getElementById("quantity-price-container");
        const dataShowquantityfield = getDiv.getAttribute("data-showquantityfield");
        return (
            <div className="quantity-price-container">
                {dataShowquantityfield && (
                    <div className="detail-container" id="BuyProductContainer">
                        <label >
                            {translate('product.detail.amount.night')}
                        </label>
                        <label id="amount-of-nights" className="detail-container__night">0</label>
                    </div>
                )}
                <div className="detail-container">
                    <label>
                        {translate('product.detail.total')}
                    </label>
                    <label className="detail-container__price" id="total-price-accommodation">0 SEK</label>
                </div>
            </div>
        )
    }

    return (
        <div className="mainContainer-bookingDates">
            <div className="bookingDates-modal">
                {isVisible && (
                    <>
                        <div className="bookingDates-modal__backdrop" onClick={handleClose}> </div>
                        <div onClick={handleClose}>
                            <div className="calendar-container">
                                <span className="close-icon" onClick={handleClose}></span>
                                {daysArray &&
                                    createDatePicker(daysArray)
                                }
                                <div className="line"></div>
                                {createDescription()}
                                {createErrorMessage()}
                                {createButtonContainers()}
                            </div>
                        </div>
                    </>
                )}
            </div>
            {createInOutcheckDateContainer()}
            {createQuantityPriceContainer()}
            {createSearchDatesButton()}
            <div hidden className="in-outcheckDates" id="in-outcheckDates" data-checkin={`${fromDate}`}
                data-checkout={`${toDate}`} date-quantity={`${quantity}`}></div>
        </div>
    )
}

export default BookingDate;